import { DefaultFilterValues, type GfxSettings } from '#src/types';

export const DrupalSettings = {
  getGeoLink(
    levelId: string,
    options: { iso3: string; sublevelId: string }
  ): string | null {
    const namespaces = {
      // original implementation used these custom namespaces
      // it's gonna be easier to maintain if we use the levelId as the namespace
      [DefaultFilterValues.regions]: 'regions',
      [DefaultFilterValues.operations]: 'countries',
    } as const;
    let namespace = namespaces[levelId as keyof typeof namespaces];

    if (!namespace) {
      console.warn(
        `Namespace ${levelId} not found. Using sublevelId ${options.sublevelId} instead.`
      );
      namespace = options.sublevelId as any;
    }
    const key = namespace === 'countries' ? options.iso3 : options.sublevelId;
    return (
      window.drupalSettings?.gfx_dashboards?.vocabularies?.[namespace]?.[key]
        ?.url ?? null
    );
  },
  getDashboardFiltersSettings(blockElementId: string): GfxSettings {
    const settings = window.drupalSettings?.gfx_dashboards?.[
      blockElementId
    ] as GfxSettings;

    if (settings) {
      const sanitizedSettings = { ...settings };
      Object.keys(sanitizedSettings).forEach((key) => {
        const filter = sanitizedSettings[key as keyof GfxSettings];
        filter.selectedValues = filter.selectedValues.filter(
          // From drupal we get lowercase 'all' when no value is selected
          // so we need to filter it out
          (value) => value !== 'all' && Boolean(value)
        );
      });

      if (sanitizedSettings.categoryId.selectedValues.length > 0) {
        const categoryIdSet = new Set(
          sanitizedSettings.categoryId.selectedValues
        );
        // We need to always include the 'ALL' value for the categoryId filter
        // the map resets category to ALL so it needs to be present.
        categoryIdSet.add('ALL');
        sanitizedSettings.categoryId.selectedValues = Array.from(categoryIdSet);
      }

      return sanitizedSettings;
    }
    return settings;
  },
};
